import { Component, OnInit, ElementRef, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestOptions, Request, RequestMethod, Http, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AppSettings } from '../../config/settings/app-settings';
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { consumerBasicInfoModel } from '../../models/consumerBasicInfo/consumerBasicInfo.model';
import { documentModel } from '../../models/documentUpload/doc.model';
import { error } from 'util';
import { DocumentTypeAll } from 'app/models/documentType/documentType';
import { consumerDetailsObject } from 'app/models/ConsumerDetailsObject/ConsumerDetailsObject';
import { Constants } from 'app/config/settings/constants';

@Component({
  selector: 'app-newnsc',
  templateUrl: './docUpload.component.html'
})

export class DocumentUploadComponent implements OnInit {

  public emdAmountNo: number;
  public errorMsg: string = "";
  public successMsg: string = "";
  public errorMsgIdentity: string = "";
  public successMsgIdentity: string = "";
  public duplicateMsgForIdentity: string = "";
  public errorMsgOwnershipMsg: string = "";
  public successMsgOwnershipMsg: string = "";
  public duplicateMsgForOwnership: string = "";
  public errorAuthMsg: string = "";
  public successAuthMsg: string = "";
  public duplicateMsgForAuth: string = "";
  public htId: number;
  public transID: string;
  public argArry = new Array();
  public sessionData: any;
  public card1: any;
  public card2: any;
  public card3: any;
  public documentModel: documentModel = new documentModel;
  public serviceOn: boolean = false;
  public showTranscId: boolean;
  public hideOtp: boolean;
  public consumerInfoDetails: consumerBasicInfoModel = new consumerBasicInfoModel();
  public supplierID: any;
  public consumerDetailsObject: consumerDetailsObject;
  public bpIdentificationCategory: any;
  public bpIdentificationCategorySapCode: any;
  public loaded: boolean = false;
  public transcId: string;
  selectedFile: File = null;
  selectedOwenershipFile: File = null
  selectedAuthorizationDocFile: File = null;
  documentTypeModel: DocumentTypeAll = new DocumentTypeAll();
  headers: Headers;
  public isHidden: boolean;
  public isHiddenOwnerShip: boolean;
  public isAuthorization: boolean;
  public isDisable: boolean;
  public suppliedId: number;
  public isLoaded: boolean;
  public isShow: boolean = true;
  public isDocUpload: boolean;
  public emd: any;
  public isProof: boolean;
  public isOwnership: boolean;
  public isAuthorize: boolean;
  public isProofUpload: boolean = true;
  public isOwnershipUpload: boolean = true;
  public isAuthorizeUpload: boolean = true;
  public verifiedId: boolean = false;
  public verifiedOwn: boolean = false;
  public documentTypeForOtherId: boolean = true;
  public documentTypeForOtherOwn: boolean = true;
  public documentTypeForOtherAuth: boolean = true;
  public isProofID: boolean = true;
  public isProofOwn: boolean = true;
  public isProofAuth: boolean = true;
  documentListForId: any;
  documentListForOwn: any;
  documentListForAuth: any;
  public card1Length: string;
  public card2Length: string;
  public card3Length: string;
  declaration: string;
  consumerData: any;
  public consumerMail: any;
  public isDeclare: boolean = true;
  public proofOfUploadFile: any;
  public ownershipFile: any;
  public authorizationFile: any;
  public isProofOfIdentityMsg: boolean = true;
  public isProofOfOwnershipMsg: boolean = true;
  public isAuthMsg: boolean = true;
  public isDuplicateMsgForOwnership: boolean = true;
  public isDuplicateMsgForAuth: boolean = true;
  public isHideSuccessMsgForIdentity: boolean = true;
  public isHidePan: boolean = true;
  public isHidePanAuth: boolean = true;
  public initiatePaymentData: any;
  public purposeID: any;
  public disableButton: boolean = true;
  public isDisableCB: boolean = false;
  public isChecked: boolean = false;
  public isShowTermsCondnts: boolean = false;
  public isTermsCond: boolean = true;
  public multiple: any;
  public consumerBasicPostData = {
    "identificationDoc": null,
    "ownershipDoc": null,
    "authorizationDoc": null
  }

  constructor(public http: HttpTestService, public session: sessionServices, public router: Router,
    private _http: HttpClient, private route: ActivatedRoute) {
    this.showTranscId = false;
    this.hideOtp = true;
    this.headers = new Headers();
    this.headers.set('Content-Type', 'multipart/form-data');
    this.isHidden = true;
    this.isAuthorization = true;
    this.isHiddenOwnerShip = true;
    this.isDisable = true;
    this.isProof = true;
    this.isOwnership = true;
    this.isAuthorize = true;
    this.consumerData = this.route.snapshot.params['consumerData'];
    this.argArry = this.consumerData.split(",");
    this.htId = this.argArry[0];
    this.transcId = this.argArry[1];
    this.purposeID = this.argArry[2];
    // this.transcId = this.route.snapshot.paramMap.get('id');
    //  document.getElementById("id1").style.display = "none";
    if (this.suppliedId == 3) {
      this.isLoaded = true;
    } else {
      this.isLoaded = false;
    }
  }

  ngOnInit() {
    var self = this;
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };

    self.http.getConsumerInfo(this.transcId).subscribe(
      (data: consumerBasicInfoModel) => {
        self.supplierID = data.suppId;
        self.emd = data.emdValue;
        this.emdAmountNo = parseInt(self.emd);
        if (self.emdAmountNo >= 500000) {
          this.disableButton = true;
        }
      },
      (error) => {
      });

    self.http.getDocumentTypeForIdInfo().subscribe(
      (data) => {
        self.documentListForId = data;
      },
      (error) => {
      })

    self.http.getDocumentTypeForOwnInfo().subscribe(
      (data) => {
        self.documentListForOwn = data;
        if (this.purposeID === "1")
          this.documentListForOwn.splice(0, 1);
        // this.documentListForOwn.filter( h => h.bpIdentificationCategorySapCode !== 'Z00001')
      },
      (error) => {
      });

    self.http.getDocumentTypeForAuthInfo().subscribe(
      (data) => {
        self.documentListForAuth = data;
      },
      (error) => {
        // self.errorMsg = error;
      })
  }

  public postPaymentData = {
    "applicationNumber": null,
    "paymentType": null,
    "amount": null,
    "paymentChannelId": null,
    "gateway": null,
  }

  showTermsCondtn() {
    if (this.isChecked) {
      this.disableButton = true;
      this.isShowTermsCondnts = false;
    } else {
      this.disableButton = false;
      this.isShowTermsCondnts = true;
    }
  }

  openTermsCondition() {
    this.isTermsCond = false;
  }

  cancelTermsCondtn() {
    this.isTermsCond = true;
  }

  onSelectCategory(prefixName) {
    var self = this;
    this.documentTypeModel.bpIdentificationCategory1 = prefixName;
    if (prefixName == 'Others') {
      this.documentTypeForOtherId = false;
    } else {
      this.documentTypeForOtherId = true;
    }

    self.http.getDocumentTypeForIdInfo().subscribe(
      (data) => {
        //    self.documentListForId = data;
        data.forEach(element => {
          if (element.bpIdentificationCategory == prefixName) {
            this.card1Length = element.documentReferNoMaxLength;
          }
        });
      },
      (error) => {
      });
  }

  onSelectCategoryForOwn(own) {
    var self = this;
    this.documentTypeModel.bpIdentificationCategory2 = own;
    if (own == 'Others') {
      this.documentTypeForOtherOwn = false;
    } else {
      this.documentTypeForOtherOwn = true;
    }

    self.http.getDocumentTypeForOwnInfo().subscribe(
      (data) => {
        data.forEach(element => {
          if (element.bpIdentificationCategory == own) {
            this.card2Length = element.documentReferNoMaxLength;
            if (this.card2Length == "10") {
              this.isHidePan = false;
            } else {
              this.isHidePan = true;
            }
          }
        });
      },
      (error) => {
        // self.errorMsg = error;
      })
  }

  onSelectCategoryForAuth(auth) {
    var self = this;
    this.documentTypeModel.bpIdentificationCategory3 = auth;
    if (auth == 'Others') {
      this.documentTypeForOtherAuth = false;
    } else {
      this.documentTypeForOtherAuth = true;
    }

    self.http.getDocumentTypeForAuthInfo().subscribe(
      (data) => {
        data.forEach(element => {
          if (element.bpIdentificationCategory == auth) {
            this.card3Length = element.documentReferNoMaxLength;
          }
          if (this.card3Length == "10") {
            this.isHidePanAuth = false;
          } else {
            this.isHidePanAuth = true;
          }
        });
      },
      (error) => {
        // self.errorMsg = error;
      });
  }

  isDisabledID(): boolean {
    if ((this.documentTypeModel.card1 == null) || (this.documentTypeModel.card1 == "")
      || (this.documentTypeModel.card1 == "undefined") || (this.isProof == true)
      || (this.documentTypeModel.bpIdentificationCategory1 == null)) {
      this.isProofID = true;
    } else {
      this.isProofID = false;
    }

    return this.isProofID;
  }

  //  isDisabledOwn() : boolean {
  //   if((this.documentTypeModel.card2 == null) || (this.documentTypeModel.card2 == "")
  //   || (this.documentTypeModel.card2 == "undefined") || (this.isOwnership == true) 
  //   || (this.documentTypeModel.bpIdentificationCategory2 == null )){

  //     this.isProofOwn = true;
  //   }else{
  //     this.isProofOwn = false;
  //   }

  //   return this.isProofOwn;
  //  }

  isDisabledAuth(): boolean {
    if ((this.documentTypeModel.card3 == null) || (this.documentTypeModel.card3 == "")
      || (this.documentTypeModel.card3 == "undefined") || (this.isAuthorize == true)
      || (this.documentTypeModel.bpIdentificationCategory3 == null)) {
      this.isProofAuth = true;
    } else {
      this.isProofAuth = false;
    }
    return this.isProofAuth;
  }

  onFileSelected(event) {
    this.isProof = false;
    this.selectedFile = <File>event.target.files[0];
  }

  onOwnerFileSelected(event) {
    this.isOwnership = false;
    this.selectedOwenershipFile = <File>event.target.files[0];
  }

  onAuthFileSelected(event) {
    this.isAuthorize = false;
    this.selectedAuthorizationDocFile = <File>event.target.files[0];
  }

  //Proof of Identity Upload
  onUpload = function () {
    this.errorMsgIdentity = "";
    this.successMsgIdentity = "";
    this.isHidden = false;

    if (this.selectedFile === null) {
      this.isProofOfIdentityMsg = false;
      this.errorMsgIdentity = "Please Choose the file";
      return;
    }

    if (this.validateFileNameFor1and2() == false) {
      this.isProofOfIdentityMsg = false;
      this.duplicateMsgForIdentity = "Duplicate file";
      return;
    } else {
      this.isProofOfIdentityMsg = true;
    }

    if (this.validateFileNameFor1and3() == false) {
      this.isProofOfOwnershipMsg = false;
      this.duplicateMsgForIdentity = "Duplicate file";
      return;
    } else {
      this.isProofOfOwnershipMsg = true;
    }

    const fd = new FormData();
    fd.append('identificationDoc', this.selectedFile, this.selectedFile.name)
    this._http.post(AppSettings.IPCL_API + '/' + this.transcId + ',' + this.documentTypeModel.bpIdentificationCategory1 + ',' + this.documentTypeModel.other1 + ',' + this.documentTypeModel.card1 + AppSettings.IDENTIFICATNUPLOAD, fd).subscribe(
      (data) => {
        this.proofOfUploadFile = data;
        if (this.proofOfUploadFile) {
          this.isProofOfIdentityMsg = false;
          this.isHideSuccessMsgForIdentity = false;
          this.successMsgIdentity = " Proof of Identity successfully Uploaded.";
          this.isDisable = false;
          this.verifiedId = true;
        } else if (!this.proofOfUploadFile) {
          this.isProofOfIdentityMsg = false;
          this.isHideSuccessMsgForIdentity = true;
          this.errorMsgIdentity = "File does not uploaded properly";
          this.isDisable = true;
        }
      },
      (error) => {
        this.isProofOfIdentityMsg = false;
        this.errorMsgIdentity = "Sorry. Your file is too large. Maximum 1MB is allowed.";
      },
    () => {
        this.serviceOn = false;
    });
  }

  //Ownership Upload
  uploadOwnershipFile = function () {
    this.successMsgOwnershipMsg = "";
    this.errorMsgOwnershipMsg = "";
    this.successMsg = "";
    this.isHiddenOwnerShip = false;

    if (this.selectedOwenershipFile === null) {
      this.isProofOfOwnershipMsg = false;
      this.errorMsgOwnershipMsg = "Please Choose the file";
      return;
    }

    if (this.validateFileNameFor1and2() == false) {
      this.isHideSuccessMsgForIdentity = true;
      this.isProofOfOwnershipMsg = false;
      this.isDuplicateMsgForOwnership = false;
      this.duplicateMsgForOwnership = "Duplicate file";
      return;
    } else {
      this.isProofOfOwnershipMsg = true;
    }

    if (this.validateFileNameFor2and3() == false) {
      this.isHideSuccessMsgForIdentity = true;
      this.isProofOfOwnershipMsg = false;
      this.isDuplicateMsgForOwnership = false;
      this.duplicateMsgForOwnership = "Duplicate file";
      return;
    } else {
      this.isProofOfOwnershipMsg = true;
    }

    const fd = new FormData();
    fd.append('ownershipDoc', this.selectedOwenershipFile, this.selectedOwenershipFile.name)
    this._http.post(AppSettings.IPCL_API + '/' + this.transcId + ',' + this.documentTypeModel.bpIdentificationCategory2 + ',' + this.documentTypeModel.other2 + ',' + this.documentTypeModel.card2 + AppSettings.OWENERSHIPUPLOAD, fd).subscribe(
        (data) => {
          this.ownershipFile = data;
          this.ownershipFile = data;
          if (this.ownershipFile) {
            this.isProofOfOwnershipMsg = false;
            this.isProofOfIdentityMsg = false;
            this.successMsgOwnershipMsg = "Proof of Ownership/Occupancy successfully Uploaded.";
            this.isDuplicateMsgForOwnership = true;
            this.isOwnershipUpload = true;
            this.verifiedOwn = true;
          } else if (!this.ownershipFile) {
            this.isProofOfOwnershipMsg = false;
            this.isProofOfIdentityMsg = false;
            this.errorMsgOwnershipMsg = "File does not uploaded properly";
            this.isDuplicateMsgForOwnership = true;
            this.isOwnershipUpload = false;
          }
        },
        (error) => {
          this.isProofOfOwnershipMsg = false;
          this.isProofOfIdentityMsg = false;
          this.errorMsgOwnershipMsg = "Sorry. Your file is too large. Maximum 2MB is allowed.";
        },
        () => {
          this.serviceOn = false;
        });
  }

  //Authorization Upload
  uploadAuthorizationFile = function () {
    this.successAuthMsg = "";
    this.errorAuthMsg = "";
    this.successMsg = "";
    this.isAuthorization = false;

    if (this.selectedAuthorizationDocFile === null) {
      this.isAuthMsg = false;
      this.errorAuthMsg = "Please Choose the file";
      return;
    }

    if (this.validateFileNameFor1and3() == false) {
      this.isHideSuccessMsgForIdentity = false;
      this.isAuthMsg = false;
      this.isDuplicateMsgForAuth = false;
      this.duplicateMsgForAuth = "Duplicate file";
      return;
    } else {
      this.isAuthMsg = true;
    }

    if (this.validateFileNameFor2and3() == false) {
      this.isHideSuccessMsgForIdentity = false;
      this.isAuthMsg = false;
      this.isDuplicateMsgForAuth = false;
      this.duplicateMsgForAuth = "Duplicate file";
      return;
    } else {
      this.isAuthMsg = true;
    }

    const fd = new FormData();
    fd.append('authorizationDoc', this.selectedAuthorizationDocFile, this.selectedAuthorizationDocFile.name)
    this._http.post(AppSettings.IPCL_API + '/' + this.transcId + ',' + this.documentTypeModel.bpIdentificationCategory3 + ',' + this.documentTypeModel.other3 + ',' + this.documentTypeModel.card3 + AppSettings.AUTHRISONUPLOAD, fd).subscribe(
        (data) => {
          this.authorizationFile = data;
          if (this.authorizationFile) {
            this.isAuthMsg = false;
            this.isDuplicateMsgForAuth = true;
            this.successAuthMsg = "Authorization successfully Uploaded.";
            this.isAuthorizeUpload = true;
            //   this.isDisable = false;
          } else if (!this.authorizationFile) {
            this.isAuthMsg = false;
            this.isDuplicateMsgForAuth = true;
            this.errorAuthMsg = "File does not uploaded properly";
            this.isAuthorizeUpload = false;
            //  this.isDisable = true;
          }
        },
        (error) => {
          this.isAuthMsg = false;
          this.errorAuthMsg = "Sorry. Your file is too large. Only 1MB is allowed.";
        },
        () => {
          this.serviceOn = false;
        });
  }

  validateFileNameFor1and2 = function () {
    if (this.selectedFile !== null && this.selectedOwenershipFile !== null) {
      if (this.selectedFile.name == this.selectedOwenershipFile.name) {
        return false;
      }
    }
  }

  validateFileNameFor2and3 = function () {
    if (this.selectedOwenershipFile !== null && this.selectedAuthorizationDocFile !== null) {
      if (this.selectedOwenershipFile.name == this.selectedAuthorizationDocFile.name) {
        return false;
      }
      return true;
    }
  }

  validateFileNameFor1and3 = function () {
    if (this.selectedAuthorizationDocFile !== null && this.selectedFile !== null) {
      if (this.selectedAuthorizationDocFile.name == this.selectedFile.name) {
        return;
      }
    }
  }

  sendMobileOtpReq = function () {
    var self = this;
    self.serviceOn = true;
    self.newNscPostData.newUserMob = self.newnscModel.newUserMob;
    this.showTranscId = true;
    this.hideOtp = false;
    // self.router.navigateByUrl('/newNscRegCompnt');
  }

  sendTranscReq = function () {
    var self = this;
    self.router.navigateByUrl(['/newNscRegCompnt'], { skipLocationChange: false });
  }

  sendConsumerInfo = function () {
    var self = this;
    this.isDocUpload = true;
    if (this.htId == 2) {
      this.isShow = true;
      this.isDeclare = false;
      document.getElementById("id1").style.display = "none";
      document.getElementById("id2").style.display = "block";
      self.http.getMailDetails(this.transcId).subscribe(
        (data) => {
            self.consumerMail = data;
          },
          (error) => {
          },
          () => { }
        );
      this.declaration = "Visit your nearest customer care center";
    } else {
      this.isShow = false;
      this.isDeclare = true;
      document.getElementById("id2").style.display = "none";
      document.getElementById("id1").style.display = "block";
      this.declaration = "";
      self.http.getTransactionDatatable(this.transcId).subscribe(
        (data: consumerDetailsObject) => {
          //self.supplierID = self.consumerInfoDetails.suppId;
          self.emd = data.emdAmount;
          this.emdAmountNo = parseInt(self.emd);
          if (self.emdAmountNo >= 500000) {
            this.disableButton = true;
          }
          JSON.stringify("EMD VALUE: " + data);
          // this.router.navigate(['/documentUploadComponent',this.transcId], { skipLocationChange: false });
        },
        (error) => {
          // self.errorMsg = error;
        });
    }
    this.isDocUpload = true;
    this.isShow = false;
    this.successMsg = "Your Application has been submitted successfully";
  }

  payEmd = function () {
    var self = this;
    var timestamp = new Date().getTime();
    var payEmdValue = 1;
    var payChannelId = 1;
    self.postPaymentData.applicationNumber = this.transcId;
    self.postPaymentData.paymentType = payEmdValue;
    self.postPaymentData.amount = self.emd;
    //self.postPaymentData.amount = 0
    self.postPaymentData.paymentChannelId = payChannelId;
    
    if(!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
      alert('amount 0')
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}

    self.http.postPayEmd(self.postPaymentData).subscribe(
      (data) => {
         self.initiatePaymentData = data.sourceSystem;
         window.location.href = AppSettings.BILLDESK_URL + "?msg=" + self.initiatePaymentData;
        },
        (error) => {
          self.errorMsg = error;
        },
        () => {
          self.successMsg = "";
          self.serviceOn = false;
        });
  }

  payWithRazorpayGateway() {
		let consumerNo: any;
		// if (this.quickPayModel.consumerId != null && this.quickPayModel.consumerId != "") {
		// 	consumerNo = this.quickPayModel.consumerId;
		// 	//alert("consumerNo"+self.consumerNo );
		// } else {
		// 	consumerNo = this.sessionData.consumerId;
		// 	//	alert("self.consumerNo"+self.consumerNo);
		// }

		// this.billAmount = 100; // TODO: remove beore production
		var paymentType = 1;
		var payChannelId = 1;
		//this.postPaymentData.consumerId = consumerNo;
		this.postPaymentData.paymentType = paymentType;
		this.postPaymentData.amount = this.emd;
		this.postPaymentData.gateway = 2;
		this.postPaymentData.paymentChannelId = payChannelId;

		if(!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}

		// initiate payment request
		this.http.postPayEmd(this.postPaymentData).subscribe((data) => {
			if(data['orderNo'] == null) { this.errorMsg = 'Could not proceed with gateway, please try gain later.'; return; }
			let orderNo: String = data['orderNo'];
			if(orderNo && orderNo.length > 0) {
				let options: any = {
					"key": Constants.rzp_key,
					"amount": (this.postPaymentData.amount * 100), /* amount to be passed as lowest currency unit */
					"name": "INDIA POWER",
					"description": "Payment",
					"image": "./assets/images/logo.jpg",
					"order_id": orderNo,
					"modal": {
						"escape": false
					},
					"prefill": {
						// "name": this.postPaymentData.consumerId,
						// "email": "gaurav.kumar@example.com",
						// "contact": "9999999999",
						// "method": 'card',
						// 'card[number]': finalObj.cardDetail.cardNumber,
						// 'card[expiry]': finalObj.cardDetail.cardExpDate,
						// 'card[cvv]': finalObj.cardDetail.cardCvv
					},
					// "notes": {
					//   "address": finalObj.addressDetail.address + ', ' + finalObj.addressDetail.landmark + ', ' + finalObj.addressDetail.city + ', ' + finalObj.addressDetail.state + '-' + finalObj.addressDetail.pincode
					// },
					// "theme": {
					// 	"color": "#0d4371"
					// }
				};
				options.handler = ((response) => {
					options['payment_response_id'] = response.razorpay_payment_id;
					this.handleRazorpayResponse(response);
				});
				options.modal.ondismiss = (() => {
					//   this.loginService.SetLoader = false;
				});
				let rzp = new this.http.nativeWindow.Razorpay(options);
				rzp.open();
			} else {
				this.errorMsg = 'Order could not be created, please try again later.';
			}

		}, (error) => {
			this.errorMsg = error;
		}, () => {
			this.successMsg = "";
			this.serviceOn = false;
		});
		
	}

	handleRazorpayResponse(razorpayResponse) {
		this.http.postRazorpayResponse(razorpayResponse).subscribe((resp) => {
			if(resp['status'] === 'success') {
				this.successMsg = resp['paymentProcessingMessage'];
				setTimeout(() => { window.location.reload(); }, 5000);
			} else {
				this.errorMsg = resp['paymentProcessingMessage'];
			}
		});
	}



  checkValueProof = function (event: any) {
    if (event.target.checked) {
      this.isProofUpload = false;
    }
    else {
      this.isProofUpload = true;
    }
  }

  checkValueOthorization = function (event: any) {
    if (event.target.checked) {
      this.isOwnershipUpload = false;
    }
    else {
      this.isOwnershipUpload = true;
    }
  }

  checkValueAuthorize = function (event: any) {
    if (event.target.checked) {
      this.isAuthorizeUpload = false;
    }
    else {
      this.isAuthorizeUpload = true;
    }
  }
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/documentUpload/docUpload.component.ts